class ProductMainCustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");

    if (!sectionId) {
      console.warn("ProductMainCustomSlider: data-sectionid is missing");
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      $(this).css({ opacity: "1" });

      const thumbsSelector = ".main-product-thumbnail-slider-" + sectionId;
      const mainSelector = ".main-product-page-slider-" + sectionId;

      const thumbsEl = document.querySelector(thumbsSelector);
      const mainEl = document.querySelector(mainSelector);

      if (!thumbsEl || !mainEl) {
        console.warn("ProductMainCustomSlider: slider elements not found", {
          thumbsSelector,
          mainSelector
        });
        return;
      }

      if (thumbsEl.swiper || mainEl.swiper) {
        return;
      }

      const galleryThumbs = new Swiper(thumbsSelector, {
        spaceBetween: 12,
        slidesPerView: 4,
        watchSlidesProgress: true,
        breakpoints: {
          0: {
            slidesPerView: 4,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 12,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 18,
          },
          1441: {
            slidesPerView: 5,
            spaceBetween: 18,
          },
        },
      });

      const galleryTop = new Swiper(mainSelector, {
        spaceBetween: 12,
        thumbs: {
          swiper: galleryThumbs,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 12,
          },
        },
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 400px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("product-main-custom-slider", ProductMainCustomSlider);

class TabTextScroll extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      if (this.initialized) return;
      this.initialized = true;

      const leftItems = document.querySelectorAll('.left-container .text');
      const rightItems = document.querySelectorAll('.right-container .slide-container');
      const headerOffset = 170;

      if (!leftItems.length || !rightItems.length) return;

      function activateAndScroll(index, enableSmooth = true) {
        const activeLeft = document.querySelector('.left-container .text[data-index="' + index + '"]');
        const target = document.querySelector('.right-container .slide-container[data-index="' + index + '"]');

        if (!activeLeft || !target) return;

        leftItems.forEach((el) => el.classList.remove('active'));
        rightItems.forEach((el) => el.classList.remove('active'));

        activeLeft.classList.add('active');
        target.classList.add('active');

        const y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: y,
          behavior: enableSmooth ? 'smooth' : 'auto',
        });
      }

      leftItems.forEach((item) => {
        item.addEventListener('click', function () {
          const index = this.getAttribute('data-index');
          activateAndScroll(index, true);

          const url = new URL(window.location.href);
          url.searchParams.set('tab_index', index);
          window.history.replaceState({}, '', url);
        });
      });

      const faqItems = document.querySelectorAll('.accordion-container .faq-item');

      faqItems.forEach((item) => {
        const header = item.querySelector('.faq-header');
        const content = item.querySelector('.content');

        if (!header || !content) return;

        header.addEventListener('click', function () {
          const isActive = item.classList.contains('active');

          if (isActive) {
            item.classList.remove('active');
            content.style.display = 'none';
          } else {
            item.classList.add('active');
            content.style.display = 'block';
          }
        });
      });

      const urlParams = new URLSearchParams(window.location.search);
      const tabIndexFromUrl = urlParams.get('tab_index');

      if (tabIndexFromUrl) {
        setTimeout(function () {
          activateAndScroll(tabIndexFromUrl, false);
        }, 300);
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 300px 0px',
    });

    observer.observe(this);
  }
}

customElements.define('tab-text-scroll', TabTextScroll);




(function () {
  function checkCustomStartAnimations() {
    const sections = document.querySelectorAll('[custom-start-animation]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      if (!rect.height) return;

      const visibleTop = Math.max(rect.top, 0);
      const visibleBottom = Math.min(rect.bottom, windowHeight);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);

      const halfSectionVisible = visibleHeight >= rect.height * 0.5;

      if (halfSectionVisible) {
        section.classList.add('active');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    checkCustomStartAnimations();

    window.addEventListener('scroll', checkCustomStartAnimations);
    window.addEventListener('resize', checkCustomStartAnimations);
  });

  document.addEventListener('shopify:section:load', function () {
    checkCustomStartAnimations();
  });
})();

class CustomRelatedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(entries[0].target);

      if (window.jQuery) {
        $(this).css({ opacity: '1' });
      } else {
        this.style.opacity = '1';
      }

      const sectionId = this.getAttribute('data-sectionid');

      if (!sectionId) return;

      const sliderSelector = '.custom-related-product--' + sectionId;
      const nextSelector = '.custom-next--' + sectionId;
      const prevSelector = '.custom-prev--' + sectionId;
      const fractionSelector = '.custom-review-fraction--' + sectionId;

      const sliderEl = this.querySelector(sliderSelector) || document.querySelector(sliderSelector);

      if (!sliderEl) return;

      if (sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
      }

      new Swiper(sliderSelector, {
        centeredSlides: false,
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: nextSelector,
          prevEl: prevSelector,
        },
        pagination: {
          el: fractionSelector,
          type: 'fraction',
          formatFractionCurrent: function (number) {
            return number < 10 ? '0' + number : number;
          },
          formatFractionTotal: function (number) {
            return number < 10 ? '0' + number : number;
          },
          renderFraction: function (currentClass, totalClass) {
            return (
              '<span class="' +
              currentClass +
              '"></span><span class="separator"> / </span><span class="' +
              totalClass +
              '"></span>'
            );
          },
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 64,
          },
        },
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 300px 0px',
    });

    observer.observe(this);
  }
}
customElements.define('custom-related-products', CustomRelatedProducts);

class ShopTheLookNew extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(entries[0].target);

      if (window.jQuery) {
        window.jQuery(this).css({ opacity: '1' });
      } else {
        this.style.opacity = '1';
      }

      this.initDesktopShopTheLook();
      this.initMobileShopTheLook();
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 300px 0px',
    });

    observer.observe(this);
  }

  initDesktopShopTheLook() {
    const sectionId = this.getAttribute('data-sectionid');

    if (!sectionId) return;

    const imageWrapper = this.querySelector('.product-image-slider--' + sectionId);
    const staticLayout = imageWrapper ? imageWrapper.querySelector('.static-image-layout') : null;
    const prevBtn = this.querySelector('.custom-arrow-prev--' + sectionId);
    const nextBtn = this.querySelector('.custom-arrow-next--' + sectionId);
    const productSliderEl = this.querySelector('.product-slider--' + sectionId);

    if (!staticLayout || !productSliderEl) return;

    let allImages = [];

    try {
      allImages = JSON.parse(staticLayout.getAttribute('data-images') || '[]');
    } catch (error) {
      console.error('ShopTheLookNew: Invalid data-images JSON', error);
      allImages = [];
    }

    const total = allImages.length;

    if (!Array.isArray(allImages) || total < 1) {
      console.warn('ShopTheLookNew: data-images is missing or empty.');
      return;
    }

    if (typeof Swiper === 'undefined') {
      console.warn('ShopTheLookNew: Swiper is not loaded.');
      return;
    }

    let activeIndex = total >= 3 ? 2 : total - 1;

    if (productSliderEl.swiper) {
      productSliderEl.swiper.destroy(true, true);
    }

    const productSlider = new Swiper(productSliderEl, {
      slidesPerView: 1,
      loop: false,
      allowTouchMove: false,
      simulateTouch: false,
      speed: 500,
      initialSlide: activeIndex,
    });

    const slots = staticLayout.querySelectorAll('.static-image-slot');

    function updateArrowButtons() {
      if (prevBtn) {
        prevBtn.classList.toggle('active-button', activeIndex > 0);
      }

      if (nextBtn) {
        nextBtn.classList.toggle('active-button', activeIndex < total - 1);
      }
    }

    function getDisplayIndexes(active) {
      if (total <= 3) {
        const indexes = [];

        for (let i = 0; i < total; i++) {
          indexes.push(i);
        }

        return indexes;
      }

      if (active === 0) {
        return [0, 1, 2];
      }

      if (active === total - 1) {
        return [total - 3, total - 2, total - 1];
      }

      return [active - 1, active, active + 1];
    }

    function renderImages() {
      const displayIndexes = getDisplayIndexes(activeIndex);

      slots.forEach((slot, slotIndex) => {
        const img = slot.querySelector('img');
        const realIndex = displayIndexes[slotIndex];

        if (!img) return;

        if (realIndex === undefined || !allImages[realIndex]) {
          slot.style.display = 'none';
          return;
        }

        slot.style.display = '';
        img.src = allImages[realIndex].image;
        img.alt = allImages[realIndex].alt || '';
        img.setAttribute('data-real-index', realIndex);

        slot.classList.toggle('is-active', realIndex === activeIndex);
        slot.classList.toggle('is-small', realIndex !== activeIndex);
      });

      productSlider.slideTo(activeIndex);
      updateArrowButtons();
    }

    function nextSlide() {
      if (activeIndex >= total - 1) return;

      activeIndex += 1;
      renderImages();
    }

    function prevSlide() {
      if (activeIndex <= 0) return;

      activeIndex -= 1;
      renderImages();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }

    slots.forEach((slot) => {
      slot.addEventListener('click', function () {
        const img = slot.querySelector('img');

        if (!img) return;

        const clickedIndex = Number(img.getAttribute('data-real-index'));

        if (Number.isNaN(clickedIndex)) return;

        activeIndex = clickedIndex;
        renderImages();
      });
    });

    renderImages();
  }

  initMobileShopTheLook() {
    const sectionId = this.getAttribute('data-sectionid');

    if (!sectionId) return;

    const sliderEl = this.querySelector('.mobile-shop-look-slider--' + sectionId);

    if (!sliderEl) return;

    if (typeof Swiper === 'undefined') {
      console.warn('ShopTheLookNew: Swiper is not loaded.');
      return;
    }

    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }

    const mobileSlider = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
    });

    function closeAllPopups() {
      sliderEl.querySelectorAll('.mobile-look-card').forEach((card) => {
        card.classList.remove('popup-open');

        const popup = card.querySelector('.mobile-hotspot-popup');

        if (popup) {
          popup.style.top = '';
          popup.style.bottom = '';
        }
      });
    }

    sliderEl.addEventListener('click', function (e) {
      const hotspot = e.target.closest('.mobile-hotspot');
      const popup = e.target.closest('.mobile-hotspot-popup');
      const card = e.target.closest('.mobile-look-card');

      if (!card) return;

      if (popup) return;

      if (hotspot) {
        const imageWrap = hotspot.closest('.mobile-look-image-wrap');
        const popupEl = card.querySelector('.mobile-hotspot-popup');

        if (!imageWrap || !popupEl) return;

        const wasOpen = card.classList.contains('popup-open');

        closeAllPopups();

        if (!wasOpen) {
          const hotspotRect = hotspot.getBoundingClientRect();
          const wrapRect = imageWrap.getBoundingClientRect();

          const dotTop = hotspotRect.top - wrapRect.top;
          const dotBottom = dotTop + hotspotRect.height;
          const wrapHeight = wrapRect.height;

          popupEl.style.top = '';
          popupEl.style.bottom = '';

          if (dotTop < wrapHeight / 2) {
            popupEl.style.top = dotBottom + 10 + 'px';
          } else {
            popupEl.style.top = 'auto';
            popupEl.style.bottom = wrapHeight - dotTop + 10 + 'px';
          }

          card.classList.add('popup-open');
        }

        return;
      }

      closeAllPopups();
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mobile-shop-look--' + sectionId)) {
        closeAllPopups();
      }
    });

    mobileSlider.on('slideChange', function () {
      closeAllPopups();
    });
  }
}

if (!customElements.get('shop-the-look-new')) {
  customElements.define('shop-the-look-new', ShopTheLookNew);
}

class CollectionGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(entries[0].target);

      if (window.jQuery) {
        window.jQuery(this).css({ opacity: '1' });
      } else {
        this.style.opacity = '1';
      }

      const sectionId = this.getAttribute('data-sectionid');
      if (!sectionId) return;

      const sliderEl = this.querySelector('.collection-slider-' + sectionId);

      if (!sliderEl) return;

      if (typeof Swiper === 'undefined') {
        console.warn('CollectionGrid: Swiper is not loaded.');
        return;
      }

      if (sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
      }

      new Swiper(sliderEl, {
        slidesPerView: 5,
        spaceBetween: 16,
        breakpoints: {
          0: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
          660: {
            slidesPerView: 5,
            spaceBetween: 60,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 80,
          },
        },
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 300px 0px',
    });

    observer.observe(this);
  }
}

if (!customElements.get('collection-grid')) {
  customElements.define('collection-grid', CollectionGrid);
}

function updateTotalHeaderHeight() {
  var header = document.querySelector('#x-header-container');
  var steps = document.querySelector('.ring-builder-header-steps');

  var headerHeight = header ? header.offsetHeight : 0;
  var stepsHeight = steps ? steps.offsetHeight : 0;

  var totalHeight = headerHeight + stepsHeight;

  document.documentElement.style.setProperty('--total-header-ring-height', totalHeight + 'px');
  document.documentElement.style.setProperty('--total-header-height', headerHeight + 'px');

  console.log('Total header height:', totalHeight);
}

document.addEventListener('DOMContentLoaded', function () {
  updateTotalHeaderHeight();

  setTimeout(updateTotalHeaderHeight, 300);
  setTimeout(updateTotalHeaderHeight, 1000);
});

window.addEventListener('resize', updateTotalHeaderHeight);
window.addEventListener('load', updateTotalHeaderHeight);

class CustomReviewSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");

    if (!sectionId) {
      console.warn("CustomReviewSlider: data-sectionid is missing");
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(entries[0].target);

      $(this).css({ opacity: "1" });

      const sliderEl = this.querySelector(".custom-review--" + sectionId);

      if (!sliderEl) {
        console.warn("CustomReviewSlider: slider element not found", {
          sectionId: sectionId,
        });
        return;
      }

      if (sliderEl.swiper) {
        return;
      }

      new Swiper(sliderEl, {
        spaceBetween: 20,
        centeredSlides: false,
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,

        navigation: {
          nextEl: ".custom-review-next--" + sectionId,
          prevEl: ".custom-review-prev--" + sectionId,
        },

        pagination: {
          el: ".custom-review-fraction--" + sectionId,
          type: "fraction",

          formatFractionCurrent: function (number) {
            return number < 10 ? "0" + number : number;
          },

          formatFractionTotal: function (number) {
            return number < 10 ? "0" + number : number;
          },

          renderFraction: function (currentClass, totalClass) {
            return (
              '<span class="' +
              currentClass +
              '"></span><span class="separator"> / </span><span class="' +
              totalClass +
              '"></span>'
            );
          },
        },

        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        },
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

if (!customElements.get("custom-review-slider")) {
  customElements.define("custom-review-slider", CustomReviewSlider);
}

class CustomTestiSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");

    if (!sectionId) {
      console.warn("CustomTestiSlider: data-sectionid is missing");
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(entries[0].target);

      $(this).css({ opacity: "1" });

      const leftSlider = this.querySelector(".left-testi-slider--" + sectionId);
      const rightSlider = this.querySelector(".right-testi-slider--" + sectionId);
      const mobSlider = this.querySelector(".mob-testi-slider--" + sectionId);

      const commonOptions = {
        direction: "vertical",
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 20,
        speed: 12000,
        allowTouchMove: false,
        simulateTouch: false,
        centeredSlides: false,
        freeMode: false,
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
      };

      if (leftSlider && !leftSlider.swiper) {
        new Swiper(leftSlider, {
          ...commonOptions,
          autoplay: {
            delay: 1,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            reverseDirection: false,
          },
        });
      }

      if (rightSlider && !rightSlider.swiper) {
        new Swiper(rightSlider, {
          ...commonOptions,
          autoplay: {
            delay: 1,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            reverseDirection: true,
          },
        });
      }

      if (mobSlider && !mobSlider.swiper) {
        new Swiper(mobSlider, {
          direction: "horizontal",
          loop: true,
          slidesPerView: 1.2,
          spaceBetween: 16,
          speed: 8000,
          centeredSlides: true,
          allowTouchMove: true,
          simulateTouch: true,
          grabCursor: true,
          watchSlidesProgress: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          autoplay: {
            delay: 1,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          breakpoints: {
            0: {
              slidesPerView: 1.44,
              spaceBetween: 16,
            },
            480: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
          },
        });
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

if (!customElements.get("custom-testi-slider")) {
  customElements.define("custom-testi-slider", CustomTestiSlider);
}